// extracted by mini-css-extract-plugin
module.exports = {"CounterContainer":"TimeCounter_CounterContainer__2P_3u","Discount":"TimeCounter_Discount__2Ox1F","Counter":"TimeCounter_Counter__4qUua"};